/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S12_Support_BodyInputs */

const tr_mesafeli_s12_support_body = /** @type {(inputs: Mesafeli_S12_Support_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`standart talepler için 24 iş saati (mesai saatleri kapsamında).`)
};

const en_mesafeli_s12_support_body = /** @type {(inputs: Mesafeli_S12_Support_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`24 business hours for standard requests (within business hours).`)
};

const de_mesafeli_s12_support_body = /** @type {(inputs: Mesafeli_S12_Support_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`24 Arbeitsstunden für Standardanfragen (innerhalb der Geschäftszeiten).`)
};

const ru_mesafeli_s12_support_body = /** @type {(inputs: Mesafeli_S12_Support_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`24 рабочих часа для стандартных обращений (в рамках рабочих часов).`)
};

/**
* | output |
* | --- |
* | "24 business hours for standard requests (within business hours)." |
*
* @param {Mesafeli_S12_Support_BodyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s12_support_body = /** @type {((inputs?: Mesafeli_S12_Support_BodyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S12_Support_BodyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s12_support_body(inputs)
	if (locale === "de") return de_mesafeli_s12_support_body(inputs)
	if (locale === "ru") return ru_mesafeli_s12_support_body(inputs)
	return tr_mesafeli_s12_support_body(inputs)
});